import "@-/com.npmjs.inobounce";
import "#register-fonts";
import "@-/com.npmjs.expo-dev-client";
import { RootLayout } from "#root-layout";
import { yn } from "@-/com.npmjs.yn";

// `yn` accepts both "1" and "true" — the `@type=boolean` schema coercion applies to the typed `ENV`
// proxy, not to this direct `process.env` read, so the value arrives as whichever string the setter
// used. See the same pattern in `frame-clock.tsx` and `root-layout-providers.tsx`.
// eslint-disable-next-line no-top/no-top-level-side-effects -- compile-time Metro-inlined env flag; must be module-scope for the require() branch below
const WEB_DEVTOOLS_DISABLED = yn(process.env.EXPO_PUBLIC_DISABLE_WEB_DEVTOOLS, {
  default: false,
});

if (__DEV__ && typeof require === "function" && !WEB_DEVTOOLS_DISABLED) {
  // `@rozenite/web` is a devtools web bridge with no role in a release bundle.
  // Loading it via a `__DEV__`-guarded require lets the release minifier drop
  // both the call and its module graph.
  //
  // Also skipped under `EXPO_PUBLIC_DISABLE_WEB_DEVTOOLS` — see the note in `Root()`: devtools
  // hosts paint full-viewport overlays on web that swallow the pointer events UI automation
  // depends on.
  // eslint-disable-next-line typescript/no-require-imports -- see above
  require("@rozenite/web");
}

export function Root() {
  // `@-/dev.improve.haniverse.components.rozenite` is a devtools bridge with no role in a
  // release bundle. Loading it via a `__DEV__`-guarded require lets the release minifier drop
  // both the call and its module graph.
  //
  // DO NOT add `EXPO_PUBLIC_DISABLE_WEB_DEVTOOLS` (or any other runtime condition) to this ternary.
  // `useRootLayoutShellDevtools` and `useRootLayoutNavigationDevtoolsGate` are HOOKS that the root
  // layout calls; making their presence depend on a second condition changes the number of hooks
  // rendered and crashes the app with
  // "Rendered more hooks than during the previous render" — the whole page becomes
  // "Han failed to start" (tried in dev-CI run 30294160699). `__DEV__` alone is safe because Metro
  // inlines it to a literal, so the branch is constant for a given bundle.
  //
  // Suppressing devtools for UI automation is handled where it is safe to do so: the TanStack
  // devtools gate in `root-layout-providers.tsx`, which reads the flag as a VALUE inside a hook that
  // is selected on `__DEV__` alone. That is also the host that actually paints the pointer-swallowing full-viewport overlay
  // (verified from the hierarchy dump: `tanstack_devtools`), so this bridge never needed gating.
  const {
    RootLayoutNavigationDevtools,
    useRootLayoutNavigationDevtoolsGate,
    useRootLayoutShellDevtools,
  } = __DEV__
    ? // eslint-disable-next-line typescript/no-require-imports -- see above
      require("@-/dev.improve.haniverse.components.rozenite")
    : {
        RootLayoutNavigationDevtools: undefined,
        useRootLayoutNavigationDevtoolsGate: undefined,
        useRootLayoutShellDevtools: undefined,
      };

  return (
    <RootLayout
      NavigationDevtools={RootLayoutNavigationDevtools}
      useNavigationDevtoolsGate={useRootLayoutNavigationDevtoolsGate}
      useShellDevtools={useRootLayoutShellDevtools}
    />
  );
}
